export const getPercentView = (num: number | null, withoutSign?: boolean) => {
  if (num === null) {
    return '-'
  }
  if (withoutSign) {
    return `${num}%`
  }
  if (num <= 0) {
    return `${num}%`
  }
  return `+${num}%`
}
